export default __webpack_public_path__ + "static/media/panel3.e0db93ec.png";